import React from 'react';
import Layout from '../../../components/common/pageLayout';
import Form from '../../../components/MasterData/PlanType/add'; // updated path for category form
import constant from '../../../constant';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { v3_edit_document_type, v3_edit_plan_type } from '../../../actions/v3/masterData';

const EditCategory = (props) => {
    const location = useLocation();
    const { data, page } = location.state || {};

    const onSubmit = (model) => {
        model.previousName = JSON.parse(atob(data))['NAME'];
        v3_edit_plan_type(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message);
                props.history.push(constant.Authedcomponent.listPlanTypeMasterData.url, {
                    page: page
                });
            } else {
                toast.error(res.error);
            }
        });
    };

    return (
        <React.Fragment>
            <Layout title="Edit Plan Type">
                <Form
                    title="Edit Plan"
                    onSubmit={onSubmit}
                    data={JSON.parse(atob(data))}
                    buttonName="Save Plan"
                />
            </Layout>
        </React.Fragment>
    );
};

export default EditCategory;
